import { render, staticRenderFns } from "./OrderShipmentTo.vue?vue&type=template&id=2b8f712f&"
import script from "./OrderShipmentTo.vue?vue&type=script&lang=ts&"
export * from "./OrderShipmentTo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports